import { render, staticRenderFns } from "./contentPricingStatus.vue?vue&type=template&id=d8573c70&"
import script from "./contentPricingStatus.vue?vue&type=script&lang=js&"
export * from "./contentPricingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports